<template>
  <!--TODO category search, give users some hints about what to search-->
  <div ref="save-extraction-form">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
              <p class="modal-close">
                <button class="btn btn-danger" @click="$emit('close')">x</button>
              </p>
            <!-- modal 1: main -->
            <save-modal-main :modalBehavior="modalBehavior" @handleSearchNpi="handleSearchNpi"
                             @selectNpi="selectNpi"
                             @slideModalTo="slideModalTo"
                             @close="close"></save-modal-main>

            <!-- modal 2: NPI Search -->
            <template v-if="isNpiSearchResultsLoaded">
              <save-modal-npi-search :modalBehavior="modalBehavior" :npiSearchResults="npiSearchResults"
                                     :searchNpiForm="searchNpiForm" @selectNpi="selectNpi"
                                     @slideModalTo="slideModalTo"></save-modal-npi-search>
            </template>

            <!-- modal 3: category search -->
            <save-modal-category-search :modalBehavior="modalBehavior"
                                        @slideModalTo="slideModalTo"
                                        @selectCategory="selectCategory">
            </save-modal-category-search>

            <!-- modal 4: (optional) procedure search -->
            <save-modal-procedure-search :modalBehavior="modalBehavior"
                                         @selectProcedure="selectProcedure"
                                         @handleSaveExtraction="handleSaveExtraction"
                                         @close="close"
                                         @slideModalTo="slideModalTo">
            </save-modal-procedure-search>

            <!-- modal 5: report date -->
            <!--<save-modal-report-date :modalBehavior="modalBehavior" @slideModalTo="slideModalTo" @close="close"-->
                                    <!--@handleSaveExtraction="handleSaveExtraction"></save-modal-report-date>-->

          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
  import {searchNpi, searchCategory} from '@/api/pdfApi';
  import {mapGetters, mapActions} from 'vuex';
  import SaveModalMain from './save-modal/SaveModalMain';
  import SaveModalNpiSearch from './save-modal/SaveModalNpiSearch';
  import SaveModalCategorySearch from './save-modal/SaveModalCategorySearch';
  import SaveModalProcedureSearch from './save-modal/SaveModalProcedureSearch';

  export default {
    name: "PdfExtractionSaveModal",
    props: {
      extractionInfos: Array,
      dob: '',
      reportDate: '',
      pdfId: {
        type: Number,
        required: true
      }
    },
    components: {
      'save-modal-main': SaveModalMain,
      'save-modal-npi-search': SaveModalNpiSearch,
      'save-modal-category-search': SaveModalCategorySearch,
      'save-modal-procedure-search': SaveModalProcedureSearch,
    },
    data() {
      return {
        categoryDesc: '',
        npiSearchResults: Array,
        npiSelected: null,
        categorySelected: null,
        procedureSelected: null,
        isNpiSearchResultsLoaded: false,

        modalBehavior: {
          showModalMain: true,
          showModalNpiSearch: false,
          showModalCategorySearch: false,
          showModalProcedureSearch: false,
          showModalFinish: false,
        },
        searchNpiForm: {
          first: '',
          last: '',
          business: '',
          phone: '',
          specialty: '',
          npi: '',
          otherId: ''
        },
      }
    },
    /*
    computed: {
      ...mapGetters('login/pdf', {
        pdfId: 'getPdfId',
      }),
    },*/

    methods: {
      ...mapActions('login/pdf', [
        'saveExtraction'
      ]),
      handleSaveExtraction() {
        // must have one: category or procedure
        if (!this.categorySelected && !this.procedureSelected) {
          alert('Your report should at least have a document type or procedure.');
          return;
        }

        // show spinning to indicate progress,
        let loader = this.$loading.show({},{
          after: this.$createElement('div',{},[`Saving report...`])
        });

        let requestParams = {
          id: this.pdfId,
          date: this.reportDate,
          npi: this.npiSelected,
          category: this.categorySelected ? this.categorySelected : 0, // Might be changed for updated db
          procedure: this.procedureSelected ? this.procedureSelected : 0,
          extractions: this.extractionInfos
        };


        /* NOTE:
          partial extraction has a format of
            source: {
              selections: Array
              rotation: Number
              referencedPages: Array
            }

          if adding a feature to extract a whole page,
          make sure the source object is of the following format:
          source: {
            pageNumber: Number // page of interest
            rotation: Number //
            scale: Number // may not be needed since the backend has a hard code value
          }
        */
        this.saveExtraction(requestParams)
            .then((id) => {
              this.$swal({
                type: 'success',
                title: 'Extraction saved',
                text: 'You can go to the Reports page to see the report.'
              }).then(() => {
                window.location.reload()
              });

              this.$emit('close');

            })
            .catch((err) => {
              console.error(err);
            })
            .finally(() => {
              loader.hide();
            });


      },
      handleSearchNpi(searchNpiForm, nextModal) {
        this.searchNpiForm = searchNpiForm;
        if (/*this.searchNpiForm.first && */this.searchNpiForm.last) {
          let loader = this.$loading.show({},{
            after: this.$createElement('div',{},[`Searching provider...`])
          });
          searchNpi(this.searchNpiForm)
              .then((npis) => {
                this.npiSearchResults = npis;
                this.isNpiSearchResultsLoaded = true;
              })
              .catch((err) => {
                this.npiSearchResults = [];           // required
                this.isNpiSearchResultsLoaded = true;
                console.error(err);
              })
              .finally(() => {
                loader.hide();
                loader = null;
              });
        }
        this.slideModalTo(nextModal);
      },
      // Can't pass by ref? have to define explicit modal transition
      slideModalTo(modal) {
        switch (modal) {
          case 'main':
            this.modalBehavior.showModalMain = true;
            this.modalBehavior.showModalNpiSearch = false;
            this.modalBehavior.showModalCategorySearch = false;
            break;

          case 'npiSearch':
            this.modalBehavior.showModalMain = false;
            this.modalBehavior.showModalNpiSearch = true;
            this.modalBehavior.showModalCategorySearch = false;
            break;

          case 'categorySearch':
            this.categorySelected = null
            this.modalBehavior.showModalMain = false;
            this.modalBehavior.showModalNpiSearch = false;
            this.modalBehavior.showModalCategorySearch = true;
            this.modalBehavior.showModalProcedureSearch = false;
            break;

          case 'procedureSearch':
            this.procedureSelected = null
            this.modalBehavior.showModalCategorySearch = false;
            this.modalBehavior.showModalProcedureSearch = true;
            this.modalBehavior.showModalFinish = false;
            break;

          case 'finish':
            this.modalBehavior.showModalProcedureSearch = false;
            this.modalBehavior.showModalFinish = true;
            break;


        }
      },
      close() {
        this.$emit('close');
      },
      selectNpi(npi) {
        this.npiSelected = npi;
      },
      selectCategory(category) {
        this.categorySelected = category;
      },
      selectProcedure(procedure) {
        this.procedureSelected = procedure;
      }

    }

  }
</script>

<style scoped lang="scss">
  @import "../../../stylesheets/modules/modal";

  p {
    margin: 0;
  }
  .modal-container {
    position: relative;
  }
  .modal-close {
    position: absolute;
    top: 10px;
    left: 20px;
  }
  .btn-danger {
    font-size: 0.8em;
    padding: 5px 11px;
    border-radius: 50%;
  }

  @media only screen and (max-width: 768px) {
    .modal-container {
      width: 100%;
    }
  }
</style>